import { Head, useForm, Link } from '@inertiajs/react'
import SuperAdminLayout from '../_SuperAdminLayout'

interface Tenant { id: number; name: string; slug: string; timezone: string; status: string }
interface Props { tenant: Tenant; errors?: Record<string, string | string[]> }

export default function TenantsEdit({ tenant, errors = {} }: Props) {
  const { data, setData, put, processing } = useForm({
    tenant: { name: tenant.name, slug: tenant.slug, timezone: tenant.timezone || 'America/New_York' }
  })

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    put(`/super_admin/tenants/${tenant.id}`)
  }

  const errText = errors.base
  const baseErr = Array.isArray(errText) ? errText[0] : errText

  return (
    <SuperAdminLayout>
      <Head title={`Edit ${tenant.name}`} />
      <div className="max-w-2xl">
        <Link href={`/super_admin/tenants/${tenant.id}`} className="text-sm text-[#ED1C24] hover:underline">&larr; {tenant.name}</Link>
        <h1 className="text-2xl font-bold text-text-primary mt-2 mb-4">Edit tenant</h1>

        {baseErr && <div className="mb-4 px-3 py-2 bg-red-50 text-red-700 rounded text-sm">{baseErr}</div>}

        <form onSubmit={submit} className="bg-white border border-stone/20 rounded-lg p-6 space-y-4">
          <Field label="Name" required value={data.tenant.name} onChange={v => setData('tenant', { ...data.tenant, name: v })} />
          <Field label="Slug" required value={data.tenant.slug} onChange={v => setData('tenant', { ...data.tenant, slug: v })} />
          <Field label="Timezone" value={data.tenant.timezone} onChange={v => setData('tenant', { ...data.tenant, timezone: v })} />

          <div className="flex justify-end gap-2 pt-2">
            <Link href={`/super_admin/tenants/${tenant.id}`} className="px-4 py-2 border border-stone/30 rounded-lg text-sm">Cancel</Link>
            <button disabled={processing} type="submit" className="px-4 py-2 bg-[#ED1C24] text-white rounded-lg text-sm font-semibold hover:bg-[#C7161E] disabled:opacity-50">
              {processing ? 'Saving…' : 'Save changes'}
            </button>
          </div>
        </form>
      </div>
    </SuperAdminLayout>
  )
}

function Field({ label, value, onChange, required }: { label: string; value: string; onChange: (v: string) => void; required?: boolean }) {
  return (
    <div>
      <label className="block text-sm font-medium text-text-primary mb-1">{label}{required && <span className="text-[#ED1C24]"> *</span>}</label>
      <input required={required} value={value} onChange={e => onChange(e.target.value)} className="w-full px-3 py-2 border border-stone/30 rounded-lg" />
    </div>
  )
}
